import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateFormatterService {
  private readonly dateFormatter: (date: Date) => string;
  private readonly dateTimeFormatter: (date: Date) => string;

  constructor() {
    try {
      const dateFormat = new Intl.DateTimeFormat([], {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      });
      const dateTimeFormat = new Intl.DateTimeFormat([], {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      });

      this.dateFormatter = (date: Date) => dateFormat.format(date);
      this.dateTimeFormatter = (date: Date) => dateTimeFormat.format(date);
    } catch (error) {
      console.error('[DateFormatterService] Error:', error);
      this.dateFormatter = (date: Date) => date.toLocaleDateString();
      this.dateTimeFormatter = (date: Date) => date.toLocaleString();
    }
  }

  public formatDate(date: Date): string {
    if (!(date instanceof Date)) {
      return '';
    }

    return this.dateFormatter(date);
  }

  public formatDateTime(date: Date): string {
    if (!(date instanceof Date)) {
      return '';
    }

    return this.dateTimeFormatter(date);
  }
}
